module.exports = __webpack_public_path__ + "assets/49b11ce3b395359eb599a6ff0824ffeb.png";